/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdateModifierGroupsRequestInnerAllOfModifiersInner } from './UpdateModifierGroupsRequestInnerAllOfModifiersInner';
import {
    UpdateModifierGroupsRequestInnerAllOfModifiersInnerFromJSON,
    UpdateModifierGroupsRequestInnerAllOfModifiersInnerFromJSONTyped,
    UpdateModifierGroupsRequestInnerAllOfModifiersInnerToJSON,
    UpdateModifierGroupsRequestInnerAllOfModifiersInnerToJSONTyped,
} from './UpdateModifierGroupsRequestInnerAllOfModifiersInner';

/**
 * 
 * @export
 * @interface PatchModifierGroupRequest
 */
export interface PatchModifierGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchModifierGroupRequest
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchModifierGroupRequest
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchModifierGroupRequest
     */
    enabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PatchModifierGroupRequest
     */
    max?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchModifierGroupRequest
     */
    min?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PatchModifierGroupRequest
     */
    allowRepeat?: boolean;
    /**
     * 
     * @type {Array<UpdateModifierGroupsRequestInnerAllOfModifiersInner>}
     * @memberof PatchModifierGroupRequest
     */
    modifiers?: Array<UpdateModifierGroupsRequestInnerAllOfModifiersInner>;
}

/**
 * Check if a given object implements the PatchModifierGroupRequest interface.
 */
export function instanceOfPatchModifierGroupRequest(value: object): value is PatchModifierGroupRequest {
    return true;
}

export function PatchModifierGroupRequestFromJSON(json: any): PatchModifierGroupRequest {
    return PatchModifierGroupRequestFromJSONTyped(json, false);
}

export function PatchModifierGroupRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchModifierGroupRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'max': json['max'] == null ? undefined : json['max'],
        'min': json['min'] == null ? undefined : json['min'],
        'allowRepeat': json['allowRepeat'] == null ? undefined : json['allowRepeat'],
        'modifiers': json['modifiers'] == null ? undefined : ((json['modifiers'] as Array<any>).map(UpdateModifierGroupsRequestInnerAllOfModifiersInnerFromJSON)),
    };
}

export function PatchModifierGroupRequestToJSON(json: any): PatchModifierGroupRequest {
    return PatchModifierGroupRequestToJSONTyped(json, false);
}

export function PatchModifierGroupRequestToJSONTyped(value?: PatchModifierGroupRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'enabled': value['enabled'],
        'max': value['max'],
        'min': value['min'],
        'allowRepeat': value['allowRepeat'],
        'modifiers': value['modifiers'] == null ? undefined : ((value['modifiers'] as Array<any>).map(UpdateModifierGroupsRequestInnerAllOfModifiersInnerToJSON)),
    };
}

